export class PageNotFoundError extends Error {
    constructor(message?: string) {
      super(message);
      this.name = 'PageNotFoundError';
      Object.setPrototypeOf(this, PageNotFoundError.prototype);
    }
  }